module.exports = __webpack_public_path__ + "db499760786c9dd364c6ed513e212341.woff";